import { farasod } from "./api"

const endpoint = "/subscription-gift"

export const validateSubscriptionGift = async (code) => {
  const response =
    await farasod.get(`${endpoint}/${code}`)

  return response.data
}